import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Input, ViewEncapsulation, PLATFORM_ID, Inject } from '@angular/core';
import { Chart, ChartModule} from 'angular-highcharts';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'kla-highchart',
  templateUrl: './highchart.component.html',
  styleUrls: ['./highchart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ CommonModule, ChartModule ]
})
export class HighchartComponent implements OnInit {

  @Input() config!: Chart;
  @Input() chartType!: number;
  limitWidth = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      const axisLabelFormatter = function(this: Highcharts.AxisLabelsFormatterContextObject) {
        if (typeof this.value !== 'number') return String(this.value);
        const v = Math.abs(this.value);
        if (v >= 1e18) return Highcharts.numberFormat(this.value / 1e18, -1) + 'E';
        if (v >= 1e15) return Highcharts.numberFormat(this.value / 1e15, -1) + 'P';
        if (v >= 1e12) return Highcharts.numberFormat(this.value / 1e12, -1) + 'T';
        if (v >= 1e9) return Highcharts.numberFormat(this.value / 1e9, -1) + 'B';
        if (v >= 1e6) return Highcharts.numberFormat(this.value / 1e6, -1) + 'M';
        if (v >= 1e3) return Highcharts.numberFormat(this.value / 1e3, -1) + 'k';
        return Highcharts.numberFormat(this.value, -1);
      };
      Highcharts.setOptions({
        lang: { thousandsSep: ',' },
        xAxis: { labels: { formatter: axisLabelFormatter } },
        yAxis: { labels: { formatter: axisLabelFormatter } }
      });
    }
  }

  ngOnInit() {
    if (this.chartType != 11) {
      this.limitWidth = true;
    }
  }

}
